import { agreement } from "@/validation/";

const step9 = ["form.affirmation", "form.agreementChange", "form.agreement"];

const step9Validations = {
  affirmation: { agreement },
  agreementChange: { agreement },
  agreement: { agreement }
};

export { step9Validations, step9 };
